import { createStore } from "vuex";
import login from "./modules/login";
import wallet from "./modules/wallet";
import dashboard from "./modules/dashboard";
import assets from "./modules/assets";
import spaces from "./modules/spaces";
import users from "./modules/users";
import reports from "./modules/reports";

export default createStore({
  state: {
    isDark: false,
    loading: false
  },
  getters: {
    getDarkMode(state){
      return state.isDark;
    },
    getLoading(state){
      return state.loading;
    }
  },
  mutations: {
    setDarkMode(state, bool){
      state.isDark = bool;
    },
    setLoading(state, loading){
      state.loading = loading;
    }
  },
  actions: {
    setDarkModeToLocaleStorage({commit}, bool){
      localStorage.setItem("dark-mode",bool);
      commit("setDarkMode", bool);
    },
  },
  modules: {
    login,
    wallet,
    dashboard,
    assets,
    spaces,
    users,
    reports
  },
});
